import { render } from "./GalleryImage.vue?vue&type=template&id=4e3f84d8"
import script from "./GalleryImage.vue?vue&type=script&lang=js"
export * from "./GalleryImage.vue?vue&type=script&lang=js"
script.render = render

export default script